import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Grid, Form, Button } from 'semantic-ui-react';
import deleteSVG from '@plone/volto/icons/delete.svg';
import { TextWidget, Icon, FormFieldWrapper } from '@plone/volto/components';

const messages = defineMessages({
  addItem: {
    id: 'vocabulary-widget-additem',
    defaultMessage: 'Add item',
  },
  key: {
    id: 'vocabulary-widget-key',
    defaultMessage: 'Key',
  },
  label: {
    id: 'vocabulary-widget-label',
    defaultMessage: 'Label',
  },
  deleteItem: {
    id: 'vocabulary-widget-delete-item',
    defaultMessage: 'Delete item',
  },
});

const DEFAULT_ITEM = {
  key: '',
  label: '',
};
const defaultConfiguration = () => [DEFAULT_ITEM];

interface VocabularyWidgetProps {
  id: string;
  value: [];
  onChange: Function;
  wrapped: boolean;
  block: string;
  disabled: boolean;
}

const VocabularyWidget: React.FC<VocabularyWidgetProps> = (props) => {
  const intl = useIntl();
  const { value, id, onChange } = props;

  const [configuration, setConfiguration] = useState(
    value
      ? typeof value === 'string'
        ? JSON.parse(value)
        : value.length == 0
        ? defaultConfiguration
        : value
      : defaultConfiguration,
  );

  const handleChangeConfiguration = (value: object) => {
    setConfiguration(value);
    onChange(id, JSON.stringify(value));
  };

  const addItem = (e: { preventDefault: Function }) => {
    e.preventDefault();

    let newConfiguration = [
      ...configuration,
      {
        ...DEFAULT_ITEM,
      },
    ];

    handleChangeConfiguration(newConfiguration);
  };

  const onChangeItem = (index: number, item: object) => {
    let newConfiguration = [...configuration];
    newConfiguration[index] = item;

    handleChangeConfiguration(newConfiguration);
  };

  const deleteItem = (e: Event, index: number) => {
    e.preventDefault();
    let newConfiguration = [...configuration];
    newConfiguration.splice(index, 1);

    handleChangeConfiguration(newConfiguration);
  };

  return (
    <FormFieldWrapper {...props}>
      <div style={{ textAlign: 'center', marginBottom: '1em' }}>
        <Button size="tiny" onClick={(e) => addItem(e)}>
          {intl.formatMessage(messages.addItem)}
        </Button>
      </div>

      <Grid stackable celled="internally">
        <Grid.Row>
          <Grid.Column width={1}></Grid.Column>
          <Grid.Column width={5}>
            <strong>{intl.formatMessage(messages.key)}</strong>
          </Grid.Column>
          <Grid.Column width={5}>
            <strong>{intl.formatMessage(messages.label)}</strong>
          </Grid.Column>
        </Grid.Row>

        {configuration.map((item, idx) => (
          <Grid.Row key={idx}>
            <Grid.Column width={1}>
              <Button
                basic
                className="cancel"
                title={intl.formatMessage(messages.deleteItem)}
                aria-label={`${intl.formatMessage(messages.deleteItem)} #${
                  idx + 1
                }`}
                onClick={(e) => deleteItem(e, idx)}
              >
                <Icon name={deleteSVG} size="20px" color="#e40166" />
              </Button>
            </Grid.Column>
            <Grid.Column width={5}>
              <TextWidget
                id="key"
                title={intl.formatMessage(messages.key)}
                description=""
                required={true}
                value={item.key}
                onChange={(id, value) => {
                  onChangeItem(idx, {
                    ...configuration[idx],
                    [id]: value?.length ? value : '',
                  });
                }}
                wrapped={false}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <TextWidget
                id="label"
                title={intl.formatMessage(messages.label)}
                description=""
                required={true}
                value={item.label}
                onChange={(id, value) => {
                  onChangeItem(idx, {
                    ...configuration[idx],
                    [id]: value?.length ? value : '',
                  });
                }}
                wrapped={false}
              />
            </Grid.Column>
          </Grid.Row>
        ))}
      </Grid>

      {configuration.length > 5 && (
        <div style={{ textAlign: 'center', marginTop: '1em' }}>
          <Button size="tiny" onClick={(e) => addItem(e)}>
            {intl.formatMessage(messages.addItem)}
          </Button>
        </div>
      )}
    </FormFieldWrapper>
  );
};

export default VocabularyWidget;
